<div class="content">
    <div class="spinner">
        <shared-spinner></shared-spinner>
    </div>
</div>